import React, { ReactElement, ReactNode, CSSProperties } from 'react';
import { LockIcon } from '../Icons';
import styled from 'styled-components';

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

const MessageContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	letter-spacing: 0.2px;
	align-items: center;
	max-width: 500px;
	width: 100%; /* Default width */

	h3 {
		color: var(--Gray-g-700, #5c5c5c);
		font-size: 32px;
		font-weight: 600;
	}
	p {
		color: var(--Gray-g-600, #7d7d7d);
		text-align: center;
		font-size: 18px;
		font-weight: 600;
	}

	/* Media query for mobile screens */
	@media screen and (max-width: 768px) {
		max-width: 80%;
	}
`;

interface CustomPermissionProps {
	icon?: ReactElement;
	title?: ReactNode;
	paragraph?: ReactNode;
	style?: CSSProperties;
	containerStyle?: CSSProperties;
	headingStyle?: CSSProperties;
	paraStyle?: CSSProperties;
}

const CustomPermission: React.FC<CustomPermissionProps> = ({
	icon = <LockIcon />,
	title = '',
	paragraph = '',
	style = {},
	containerStyle = {},
	headingStyle = {},
	paraStyle = {},
}): ReactElement => {
	return (
		<CenteredContainer style={containerStyle}>
			<MessageContainer style={style}>
				{icon}
				<h3 style={headingStyle}>{title}</h3>
				<p style={paraStyle}>{paragraph}</p>
			</MessageContainer>
		</CenteredContainer>
	);
};

export default CustomPermission;
